import React, { useState, useEffect } from "react";
import { NavLink, useLocation } from "react-router-dom";

export default function MenuItemDropdown(props) {

	const { item, icon, label, premiumIcon, submenu } = props;

	const [subMenu, setSubMenu] = useState([]);
	const [isOpen, setIsOpen] = useState(false);
	const [menuActive, setMenuActive] = useState("");
	const [linkActiveStyle, setLinkActiveStyle] = useState("");

	const location = useLocation();

	useEffect(() => {
		setSubMenu(submenu);

		const f = submenu.find(menu => `/admin/${menu.url}` === window.location.pathname);
		setMenuActive(f !== undefined ? "show" : "");
		setLinkActiveStyle(f !== undefined ? "menuCurrent" : "");
		setIsOpen(true);
	}, []);


	useEffect(() => {
		const f = submenu.find(menu => `/admin/${menu.url}` === window.location.pathname);
		setMenuActive(f !== undefined ? "show" : "");
		setLinkActiveStyle(f !== undefined ? "menuCurrent" : "");
	}, [window.location.pathname]);
	
	//  const activePath = () => {
	// 	const activeUrls = props.activeUrls || [];
	// 	return activeUrls.find((path) => location.pathname.includes(path));
   	// };
const isPathActive = (pathname, activeUrls = []) => {
  const cleanPath = pathname.replace(/^\/|\/$/g, "");

  return activeUrls.some((url) => {
    const cleanUrl = url.replace(/^\/|\/$/g, "");
    return (
      cleanPath === cleanUrl ||
      cleanPath.startsWith(cleanUrl + "/")
    );
  });
};


const activePath = () => {
  const pathname = location.pathname.replace("/admin/", "");
  const searchParams = new URLSearchParams(location.search);
  const mockSource = searchParams.get('mock');
  
  // Special handling for progress page with mock parameter
  if (pathname.startsWith('progress/') && mockSource !== null) {
    if (label === 'Mock Tests' && mockSource === '1') return true;
    if (label === 'Extensive Mock Tests' && mockSource === '2') return true;
    if (label === 'Dashboard' && mockSource === '0') return true;
    return false;
  }
  
  return isPathActive(
    pathname,
    props.activeUrls
  );
};

	return (
		<>
			{isOpen &&
				<>
					<a href="#"
						className={`dropdown-toggle ${activePath() ? "menuCurrent" : ""} ${menuActive}`}
						role="button"
						id={`dropdownMenuButton${item}`}
						data-bs-toggle="dropdown" 
						aria-expanded="false"
					>
						{/* <span className={`menuIcon ${icon}`}></span> */}
						<img className="menuIcon" src={`${icon}`} alt="LA" />
						<span className={`menuText ${premiumIcon ? "crownIcon" : ""}`}>{label}</span>
					</a>
					<ul className={`dropdown-menu ${menuActive}`} id="menuSideBarDropDown" aria-labelledby={`dropdownMenuButton${item}`}>
						{subMenu.map((menu, key) => {
							return (
								<li className="menuItem" key={key}>
									<NavLink className={({ isActive }) => (isActive ? "menuCurrent" : "")} to={`/admin/${menu.url}`}>{menu.label}</NavLink>
								</li>
							)
						})}
					</ul>
				</>
			}
		</>
	);
}
